export default __webpack_public_path__ + "static/media/switch.ffc758b9.svg";